import common from 'plugins/i18n/common.de.ts'
import entity from 'plugins/i18n/entity/index.de.ts'
import component from 'plugins/i18n/locales/component/index.de.ts'
import routeTitle from 'plugins/i18n/routeTitles.de.ts'
import notificationTypes from 'plugins/i18n/notificationTypes.de.ts'
import { file } from './file'

export const de = {
	entity,
	component,
	common,
	routeTitle,
	notificationTypes,
	file,
}
